import React, { useState } from "react";
import { SocialMediaLinkModel } from "../models/SocialMediaLinkModel";
import { PageModel } from "../models/PageModel";
import { AppConstant } from "../constant/AppConstant";
import { openUrl } from "../helper/utility";
import { CompanyInfoModel } from "../models/CompanyInfoModel";
import { Link } from "react-router-dom";
import { ROUTES } from "../routes/Routes";
import { useResponsive } from "../helper/useResponsive";
import logo from "../assets/icons/logo.png";
import payment1 from "../assets/icons/payment_zip.svg";
import payment2 from "../assets/icons/payment_visa.svg";
import payment3 from "../assets/icons/payment_afterpay.svg";
import payment4 from "../assets/icons/payment_master_card.svg";
import payment5 from "../assets/icons/payment_strip.svg";
import locationIcon from "../assets/icons/unselected_location.svg";
import emailIcon from "../assets/icons/email.svg";
import phoneIcon from "../assets/icons/phone.svg";
import downArrow from "../assets/icons/down_arrow.svg";
import upArrow from "../assets/icons/selected_up_arrow.svg";
import "../assets/css/Footer.css";

interface FooterProps {
    socialMediaLink: SocialMediaLinkModel[];
    dynamicServices: PageModel[];
    companyInfos: CompanyInfoModel[];
}

const Footer = ({
    socialMediaLink,
    dynamicServices,
    companyInfos
}: FooterProps) => {
    const isMobile = useResponsive().isMobile;
    const [openSection, setOpenSection] = useState<string | null>(isMobile ? "help" : null);

    const toggleSection = (section: string) => {
        setOpenSection(openSection === section ? null : section);
    };

    const [paymentList] = useState<string[]>([payment1, payment2, payment3, payment4, payment5]);

    const filteredFooterDesc =
        companyInfos.filter((item) => item.type === 4) || [];

    const filteredFooterAddress =
        companyInfos.filter((item) => item.type === 1) || [];

    const filteredFooterNumber =
        companyInfos.filter((item) => item.type === 2) || [];

    const filteredFooterEmail =
        companyInfos.filter((item) => item.type === 3) || [];


    return (
        <footer className="footer">
            <div className="footer-container">

                <div className="footer-section">
                    <img src={logo} alt="SOS Logo" className="footer-logo" />
                    <h3 className="footer-title">SOS Tyres and Wheels</h3>

                    <p className="footer-text">
                        {filteredFooterDesc.length > 0
                            ? filteredFooterDesc.map((item) => item.title).join(", ")
                            : " "}
                    </p>

                    <p className="footer-abn">ABN : 19652270187</p>
                </div>

                <div className="footer-section">
                    <div className="footer-header-item" onClick={() => toggleSection("help")}>
                        <h3 className="footer-title" >
                            {isMobile ? "Contact Info" : "Need Help?"}
                        </h3>
                        {isMobile && (<img src={downArrow} alt="arrow" />)}
                    </div>

                    {(!isMobile || openSection === "help") && (
                        <>
                            <div className="footer-item">
                                <img src={locationIcon} alt="location" />
                                <span>
                                    {filteredFooterAddress.length > 0
                                        ? filteredFooterAddress.map((item, index) => (
                                            <React.Fragment key={index}>
                                                {item.title}
                                                <br />
                                            </React.Fragment>
                                        ))
                                        : ""}
                                </span>
                            </div>
                            <div className="footer-item">
                                <img src={phoneIcon} alt="phone" />
                                <span>
                                    {filteredFooterNumber.length > 0
                                        ? filteredFooterNumber
                                            .map((item) => item.title)
                                            .join(", ")
                                        : " "}
                                </span>
                            </div>
                            <div className="footer-item">
                                <img src={emailIcon} alt="email" />
                                <span>
                                    {filteredFooterEmail.length > 0
                                        ? filteredFooterEmail
                                            .map((item) => item.title)
                                            .join(", ")
                                        : " "}
                                </span>
                            </div>
                        </>
                    )}
                </div>

                <div className="footer-section footer-links">
                    <div className="footer-header-item" onClick={() => toggleSection("info")}>
                        <h3 className="footer-title" >
                            Information
                        </h3>
                        {isMobile && (<img src={downArrow} alt="arrow" />)}
                    </div>
                    {(!isMobile || openSection === "info") && (
                        <div className="footer-item">
                            <ul>
                                <li><Link to={ROUTES.ABOUT_US.path}>About Us</Link></li>
                                <li><Link to={ROUTES.CONTACT_US.path}>Contact us</Link></li>
                                <li><Link to={ROUTES.BLOG.path}>Blog</Link></li>
                                <li><Link to={ROUTES.PRIVACY_POLICY.path}>Privacy Policy</Link></li>
                                <li><Link to={ROUTES.SHIPPING_POLICY.path}>Shipping Policy</Link></li>
                                <li><Link to={ROUTES.RETURN_POLICY.path}>Return & Refund Policy</Link></li>
                                <li><Link to={ROUTES.TERMS_CONDITION.path}>Terms & Condition</Link></li>
                            </ul>
                        </div>
                    )}
                </div>

                <div className="footer-section footer-links">
                    <div className="footer-header-item" onClick={() => toggleSection("services")}>
                        <h3 className="footer-title" >
                            Services
                        </h3>
                        {isMobile && (<img src={downArrow} alt="arrow" />)}
                    </div>

                    {(!isMobile || openSection === "services") && (
                        <div className="footer-item">
                            <ul>
                                {[
                                    { label: "Tyre Sales", slug: "tyre-sale" },
                                    { label: "Onsite Fitting", slug: "onsite-fitting" },
                                    { label: "Puncture Repair", slug: "puncture-repair" },
                                    { label: "Tyre Rotation", slug: "tyre-rotation" },
                                    { label: "Wheel Balancing", slug: "wheel-balancing" },
                                    ...dynamicServices.map(s => ({ label: s.title, slug: s._id }))
                                ].map((item, idx) => (
                                    <li key={`services_${idx}`}>
                                        <Link to={ROUTES.MOBILE_OR_DYNAMIC_SERVICES.path.replace(":param", item.slug ?? "")}>
                                            {item.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                </div>
            </div>

            <div className="footer-bottom">
                <div className="footer-social">
                    <span>Join Us:</span>
                    {socialMediaLink.map((socialMedia, index) => {
                        return (
                            <img key={`social_media_${index}`}
                                src={`${AppConstant.IMAGE_BASE_URL}${socialMedia.icon_image}`}
                                alt="socialMedia"
                                onClick={() => openUrl(socialMedia.social_media_url, true)}
                            />
                        );
                    })}
                </div>

                <div className="footer-payments">
                    {paymentList.map((payment, index) => {
                        return (
                            <img src={payment} alt="payment" key={`payment_${index}`} />
                        );
                    })}
                </div>
            </div>

            <p className="footer-copy">
                Copyright © {new Date().getFullYear()} All Rights Reserved by{" "}
                <span
                    className="footer-link"
                    onClick={() => openUrl("https://www.logicraftinfotech.com/", true)}
                >
                    Logicraft Infotech
                </span>
            </p>
        </footer>
    );
};

export default Footer;
